export default "__VITE_ASSET__2c5af4fa__"